export enum links {
  Hero = "Hello",
}
